import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/phone/actionTypes';
import { updatePhone } from './utils';

export default function* listenCheckVerificationCodeSuccess() {
  yield takeEvery(actionTypes.CHECK_VERIFICATION_CODE_SUCCESS, updatePhone);
}
